// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"231":"87df9951","272":"41aab9a2","607":"96cfdf61","658":"41aab9a2","662":"96cfdf61","676":"96cfdf61","960":"be73c2fc"}[chunkId] + ".chunk.css";
};